<template>
  <div class="pinyin-grid-wrap">
    <div ref="grid" class="pinyin-grid-input" v-show="!input">
      <div :class="wordClassesProcess(item, index)" v-for="(item, index) in items" :key="index" :data-index="index">
        <editable class="word-pinyin" v-if="item !== newline" v-model="pinyins[index]"></editable>
        <editable class="word-text" v-if="item !== newline" v-model="items[index]"></editable>
      </div>
    </div>
    <div class="pinyin-text-input" v-show="input">
      <div class="input-wrap">
        <PinyinInput v-model="inputPinyin" :text="inputText" type="textarea" resize="none" :autosize="{minRows:1}" placeholder="在这里输入拼音"></PinyinInput>
        <el-input type="textarea" v-model="inputText" resize="none" :autosize="{minRows:1}" placeholder="在这里输入文本"></el-input>
      </div>
      <PinyinPreview :text="previewText" :pinyin="previewPinyin" :popover="!previewStatic" :class="previewClasses"></PinyinPreview>
    </div>
    <div class="tools">
      <a class="toggle" @click="toggle">切换编辑器</a>
    </div>
  </div>
</template>

<script>
import editable from './Editable'
import PinyinPreview from "@/components/PinyinPreview"
import PinyinInput from "@/components/PinyinInput"

export default {
  name: 'PinyinGridInput',
  components: { 
    PinyinPreview,
    PinyinInput,
    editable 
  },
  props: {
    text: String,
    pinyin: String,
    inputFilter: Function,
    previewStatic: Boolean,
    previewClasses: [String, Object, Array],
    previewFilter: Function,
    wordTags: Object
  },
  data () {
    return {
      items: this.text2Array(this.text),
      pinyins: this.text2Array(this.pinyin),
      inputText: this.text,
      inputPinyin: this.pinyin,
      nativeText: this.text,
      nativePinyin: this.pinyin,
      input: true,
      newline: "\n"
    }
  },
  watch: {
    items (val) {
      let text = this.array2text(val)
      if (this.nativeText !== text) {
        // console.log('items', text, 'nativeText', this.nativeText)
        this.nativeText = text
        this.inputText = text
        this.$emit('update:text', text)
      }
    },
    pinyins (val) {
      let text = this.array2text(val)
      if (this.nativePinyin !== text) {
        // console.log('pinyins', text, 'nativePinyin', this.nativePinyin)
        this.nativePinyin = text
        this.inputPinyin = text
        this.$emit('update:pinyin', text)
      }
    },
    text (val) {
      if (this.nativeText !== val) {
        // console.log('text', val, this.nativeText)
        this.nativeText = val
        this.inputText = val
        this.items = this.text2Array(val)
      }
    },
    pinyin (val) {
      if (this.nativePinyin !== val) {
        // console.log('pinyin', val, this.nativePinyin)
        this.nativePinyin = val
        this.inputPinyin = val
        this.pinyins = this.text2Array(val)
      }
    },
    inputText (val) {
      if (this.nativeText !== val) {
        // console.log('inputText', val, this.nativePinyin)
        if (this.inputFilter) {
          val = this.inputFilter(val, 'text')
        }
        this.nativeText = val
        this.items = this.text2Array(val)
        this.$emit('update:text', val)
      }
    },
    inputPinyin (val) {
      if (this.nativePinyin !== val) {
        // console.log('inputPinyin', val, this.nativePinyin)
        if (this.inputFilter) {
          val = this.inputFilter(val, 'pinyin')
        }
        this.nativePinyin = val
        this.pinyins = this.text2Array(val)
        this.$emit('update:pinyin', val)
      }
    }
  },
  computed: {
    previewText () {
      if (this.previewFilter) {
        return this.previewFilter(this.inputText, 'text')
      }
      return this.inputText
    },
    previewPinyin () {
      if (this.previewFilter) {
        return this.previewFilter(this.inputPinyin, 'pinyin')
      }
      return this.inputPinyin
    }
  },
  mounted () {
    this.$refs.grid.addEventListener('paste', this.onPaste)
    this.$refs.grid.addEventListener('dragover', this.onDragover)
    this.$refs.grid.addEventListener('drop', this.onDrop)
    this.$refs.grid.addEventListener('keydown', this.onKeydown)
    // this.$refs.grid.addEventListener('input', this.onInput)
  },
  beforeDestroy () {
    this.$refs.grid.removeEventListener('paste', this.onPaste)
    this.$refs.grid.removeEventListener('dragover', this.onDragover)
    this.$refs.grid.removeEventListener('drop', this.onDrop)
    this.$refs.grid.removeEventListener('keydown', this.onKeydown)
    // this.$refs.grid.removeEventListener('input', this.onInput)
  },
  methods: {
    text2Array (text) {
      if (!text) return []
      let arr = []
      text.split("\n").forEach(s => {
        arr = arr.concat(["\n"], s.split(' '))
      })
      return arr.slice(1)
    },
    array2text (array) {
      return array.join(' ').replace(/ \n /g, "\n")
    },
    onPaste (event) {
      event.preventDefault()
      return false
    },
    onDragover (event) {
      event.preventDefault()
      return false
    },
    onDrop (event) {
      event.preventDefault()
      return false
    },
    onKeydown (event) {
      // console.log(event.keyCode)
      if (event.keyCode === 8) {
        let el = event.target
        let index = this.getIndex(el)
        let range = window.getSelection().getRangeAt(0)
        if (!el.innerText) {
          this.getList(el).splice(index, 1)
          this.prevFocus(el)
          event.preventDefault()
          return false
        } else if (range.startOffset === 0 && range.endOffset === 0) {
          if (index > 0) {
            let list = this.getList(el)
            this.$set(list, index - 1, list[index - 1] + list[index])
            list.splice(index, 1)
          }
          this.prevFocus(el)
          event.preventDefault()
          return false
        }
      } else if (event.keyCode === 13) {
        event.preventDefault()
        return false
      } else if(event.keyCode === 37) {
        let range = window.getSelection().getRangeAt(0)
        if (range.startOffset === 0 && range.endOffset === 0) {
          this.prevFocus(event.target)
          event.preventDefault()
          return false
        }
      } else if(event.keyCode === 39) {
        let range = window.getSelection().getRangeAt(0)
        if (range.startOffset === event.target.innerText.length) {
          this.nextFocus(event.target)
          return false
        }
      } else if (event.keyCode === 32) {
        let el = event.target
        let index = this.getIndex(el)
        let list = this.getList(el)
        let range = window.getSelection().getRangeAt(0)
        let beforeText = range.startOffset > 0 ? el.innerText.substring(0, range.startOffset) : ''
        let afterText = el.innerText.substring(range.endOffset)
        this.$set(list, index, beforeText)
        list.splice(index + 1, 0, afterText)
        this.$nextTick(() => {
          this.nextFocus(el)
        })
        event.preventDefault()
        return false
      } else if(event.keyCode === 9) {
        if (this.nextFocus(event.target)) {
          event.preventDefault()
          return false
        }
      }
    },
    getIndex (el) {
      return Number.parseInt(el.parentElement.dataset.index)
    },
    getList (el) {
      if (el.classList.contains('word-text')) {
        return this.items
      }
      return this.pinyins
    },
    prevFocus (el) {
      let expr = el.classList.contains('word-text') ? '.word-text' : '.word-pinyin'
      let prev = el.parentElement.previousElementSibling
      if (prev) {
        return this.moveCursor(prev.querySelector(expr), false)
      }
      return false
    },
    nextFocus (el) {
      let expr = el.classList.contains('word-text') ? '.word-text' : '.word-pinyin'
      let next = el.parentElement.nextElementSibling
      if (next) {
        return this.moveCursor(next.querySelector(expr), true)
      }
      return false
    },
    moveCursor (node, start) {
      if (!node) return false
      node.focus()
      window.setTimeout(() => {
        let sel = window.getSelection()
        sel.selectAllChildren(node)
        start ? sel.collapseToStart() : sel.collapseToEnd()
      }, 1)
      return true
    },
    toggle () {
      this.input = !this.input
    },
    wordClassesProcess (item, index) {
      let classes = {'word-item': true, 'newline': item === this.newline}
      if (this.wordTags) {
        for(let k in this.wordTags) {
          if (this.wordTags[k].test(item)) {
            classes[k] = true
          }
        }
      }
      return classes
    }
  }
}
</script>

<style lang="scss">
.pinyin-grid-wrap{
  position: relative;
  > .tools {
    display: block;
    margin-top: 3px;
    color: #409EFF;
    line-height: 1;
    a{
      cursor: pointer;
    }
  }
  textarea {
    min-height: 40px !important;
    line-height: 22px;
    padding-top: 8px;
    padding-bottom: 8px;
  }
}
.pinyin-text-input{
  > .input-wrap{
    > div + div{
      margin-top: 5px;
    }
  }
}
.pinyin-grid-input{
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #DCDFE6;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 5px 10px;
  outline: none;
  .word-item{
    padding: 3px;
    outline: none;
    font-size: 18px;
  }
  .word-pinyin,
  .word-text{
    line-height: 1.2;
    height: 1.3em;
    min-width: 1.2em;
    text-align: center;
    outline: none;
  }
  .word-text{
    border-top: 1px solid #DCDFE6;
    padding-top: 3px;
    margin-top: 4px;
  }
  .newline{
    width: 100%;
    height: 1px;
    border: 0;
    background-color: #DCDFE6;
    padding: 0;
    margin: 5px 0;
  }
  &:hover{
    border-color: #C0C4CC;
  }
}
</style>